// @flow
import React from 'react'

import PlainDropdownSurface, { SurfaceType } from '../plain-dropdown-surface'
import PlainIcon, { iconTypes, colorTypes } from '../plain-icon'
import DateMonthContent from './date-month-content'

import styles from './plain-date-month-picker.module.scss';

export type DateMonthPickerProps = {
  className?: string,
  date?: string,
  dateFormat?: string,
  monthsAmount?: number,
  hideDateMonthSwitcher?: boolean,
  monthsInFuture?: number,
  daysViewCondition?: (date: string) => boolean,
  onChangeDate?: (date: string, format: string, daily: boolean) => void,
}

const PlainDateMonthPicker = ({
  date,
  dateFormat,
  className,
  monthsAmount,
  hideDateMonthSwitcher,
  monthsInFuture,
  daysViewCondition,
  onChangeDate,
}: DateMonthPickerProps) => {
  return (
    <PlainDropdownSurface
      id="date_surface"
      type={SurfaceType.Menu}
      surfaceContent={(toggle) => (
        <DateMonthContent
          date={date}
          dateFormat={dateFormat}
          panelClose={toggle}
          daysViewCondition={daysViewCondition}
          monthsAmount={monthsAmount}
          onChangeDate={onChangeDate}
          hideDateMonthSwitcher={hideDateMonthSwitcher}
          monthsInFuture={monthsInFuture}
        />
      )}
      className={className}
    >
      {(onOpenClose, opened, areaProps) => (
        <button type="button" onClick={onOpenClose} className={styles.button} {...areaProps}>
          <PlainIcon
            className={styles.icon}
            type={iconTypes.CALENDAR}
            colorType={opened ? colorTypes.COLOR_PRIMARY : colorTypes.COLOR_GRAY}
            width={18}
            height="auto"
          />
        </button>
      )}
    </PlainDropdownSurface>
  )
}

export default PlainDateMonthPicker
